// surveyStatus — estado de las encuestas del jugador, compartido por toda la app.
// v6.11.329: antes cada bloqueo (Inicio, Partidos, gates de acciones) pedía las
// encuestas por su cuenta; al responder en uno, los otros seguían viéndola
// pendiente. Ahora SurveyStatusProvider (App) las pide una vez y todos leen de acá.

import { createContext } from 'react';
import type { ActiveSurveyPhase } from '../services/api/surveys';

export interface SurveyStatus {
  /** Abiertas, accesibles y sin responder. */
  pendingPhases: ActiveSurveyPhase[];
  hasPending: boolean;
  /** La que hay que responder sí o sí antes de usar la app (REGULAR primero). */
  mustAnswer: ActiveSurveyPhase | null;
  loading: boolean;
  /** Ya llegó la primera respuesta. */
  initialized: boolean;
  refresh: () => Promise<ActiveSurveyPhase[]>;
}

export const SurveyStatusContext = createContext<SurveyStatus | null>(null);
